import { AppService } from "app/services/app.service";

import { AppFilter } from "app/models/app-filter.model";
import { Recurso } from "app/models/recurso.model";
import { Observable } from "rxjs";

export abstract class AbRecurso extends AppService {
  abstract prefixo: string;
  abstract desativar(id: number);
  abstract getAllRecursos(filter: AppFilter);
  abstract getAllDispositivo(dispositivoId: number);
  abstract getRecurso(id: number);
  abstract saveRecurso(recurso: Recurso): Observable<Recurso>;
  abstract saveListaRecurso(recurso: Recurso[]): Observable<boolean>;
  abstract ListByDivisao(divisaoId: number);
  abstract ListByArea(areaId: number);

}